<template>
  <div id="page">
    <div align="center" style="margin-top: 48px;">
      <div>
        <img src="static/sczhbank/img_order_result.png" width="96px" height="72px" />
      </div>
      <div style="margin-top: 8px;">
        <label>上传图片正在审核中</label>
      </div>
      <div style="margin-top: 8px;">
        <label>我们将在24小时内完成审核</label>
      </div>
      <div style="margin-top: 8px;">
        <label>此期间请不要申请新的卡片</label>
      </div>
      <div style="margin-top: 8px;">
        <label>否则将有可能导致此次申请开卡失败</label>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'OrderResult_sczh',
    data() {
      return {
        orderNo: ''
      }
    },
    beforeRouteLeave(to, from, next) {
      console.log('beforeRouteLeave')
      console.log('to', to)
      console.log('from', from)
      next()
    },
    mounted: function() {
      this.orderNo = this.$route.params.orderNo;
      console.log("orderNo:" + this.orderNo);
    },
    destroyed: function() {
      this.toHomeHs();
    },
    methods: {
      toHomeHs: function() {
        let history_current = window.history.length;
        console.log("history_current:" + history_current)
        this.$router.go(-1)
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/sichuanzhonghang/OrderResult_sczh.vue